import React from "react";
import logoUrl from "../assets/jt-logo.png";

/**
 * Official Jumpseat Therapy emblem.
 * Gold "JT" with paper-airplane mark in an oval frame on black.
 */
export const JTLogo = ({ size = 96, withWordmark = false }) => {
  return (
    <div
      className="flex flex-col items-center gap-3"
      data-testid="jt-logo"
    >
      <img
        src={logoUrl}
        alt="Jumpseat Therapy"
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
          // The source already sits on black, so it blends seamlessly with the site
          // background. No drop-shadow or filter — keeps it crisp.
        }}
        draggable={false}
      />

      {withWordmark && (
        <div className="flex flex-col items-center gap-2 mt-1">
          <div className="gold-divider" />
          <div
            className="font-label gold-text"
            style={{ fontSize: "11px", letterSpacing: "0.45em" }}
          >
            JUMPSEAT THERAPY
          </div>
        </div>
      )}
    </div>
  );
};

export default JTLogo;
